import React from 'react';
import { motion } from 'framer-motion';
const benefits = [{
  emoji: '⚡',
  title: 'Más claridad con tus números',
  desc: 'Entendés mejor tus costos, tus precios y cómo cuidar tu rentabilidad.'
}, {
  emoji: '💬',
  title: 'Más orden al comunicarte con clientas',
  desc: 'Dejás de responder todo desde cero y empezás a usar mensajes más claros y profesionales.'
}, {
  emoji: '🗂️',
  title: 'Más estructura en tu operación diaria',
  desc: 'Tu negocio deja de sentirse caótico y empieza a funcionar con más orden.'
}, {
  emoji: '📈',
  title: 'Más seguridad para crecer',
  desc: 'Tomás decisiones con más criterio, más control y menos agotamiento mental.'
}];
export function Benefits() {
  return <section className="py-20 bg-ocean-cream" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-4">
            Lo que va a cambiar en tu negocio
          </h2>
          <p className="text-lg text-gray-600" data-id="element-5">
            Resultados que se sienten cuando dejás de improvisar
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-6">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-soft text-center flex flex-col items-center" data-id="element-7">
              <div className="w-16 h-16 bg-ocean-blue rounded-full flex items-center justify-center text-3xl mb-6" aria-hidden="true" data-id="element-8">
                {benefit.emoji}
              </div>
              <h3 className="text-lg font-bold mb-3 text-gray-900" data-id="element-9">
                {benefit.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-10">
                {benefit.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}